// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"vendorPass_wrapper__2Cwfh"};